<div class="widget-spacing">
    <div *ngFor="let item of cards; let first = isFirst">
        <div class="card">
            <div class="card-body">
                <div class="">
                    <div class="col-12"><span style="white-space: nowrap;">{{item.name}}</span>
                        <h1 *ngIf="item.value != 'Unlimited'">{{item.value}}</h1>
                        <h3 *ngIf="item.value == 'Unlimited'" style="margin-top: 10px; margin-bottom: 12px;">{{item.value}}</h3>
                    </div>
                </div>
                <div class="progress-showcase" *ngIf="first || item.value == 'Unlimited'; else restElement">
                    <div class="progress sm-progress-bar ">
                        <div class="bg-primary progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0"
                            aria-valuemax="100" style="width: 100%;"></div>
                    </div>
                </div>

                <ng-template #restElement>
                    <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                            <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"
                                class="progress-bar" [ngClass]="getClassStyle(item.value, TOTAL)"
                                [style.width]="getPercentage(item.value, TOTAL)">
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>